<script>
  export default {
    name: "ViewSticky",
  }
</script>
<style lang="sass">

    @import ../../common/styles/settings
    @import ../../common/styles/mixins
    .sticky
        //background-color: #0a6fb4
        position: fixed
        z-index: 999
        display: flex
        align-items: center
        justify-content: center
        background: $color-background-light
        transition: transform $speed-long $authentic-motion-out
        transform: translate(0, 0%)

        &--float
            width: 11rem
            bottom: 1rem
            right: 1rem
            flex-direction: column
            padding: 1rem
            border-radius: 7px
            p
                text-align: center
                margin: 0.5rem 0
            .button
                width: 100%
                text-align: center
                font-size: 12px
                padding: 0.5rem
            +media("<=1000px")
              display: none

        &--banner
            width: 95%
            margin: auto
            flex-direction: row
            justify-content: center
            align-items: baseline
            box-shadow: 0 5px 14px rgba(0, 0, 0, 0.1)
            border: 1px solid #B9B9B9
            border-radius: 0
            right: 1.5rem
            +media("<=1000px")
              display: flex
              flex-direction: column
              align-items: center
              padding: 3% 0
              width: 100%
              right: 0
              margin-bottom: 2%
            +media("<=475px")
              margin-bottom: 4%

        &__title-container
          display: flex
          flex-direction: row
          margin: auto 0
          +media("<=1000px")
            margin-bottom: 3%
          +media("<=768px")
            margin-bottom: 2%


        &__icon
            margin: auto 0
            img, svg
                display: block
            svg
                width: 2.5rem
                height: 2.5rem
                margin: auto
            +media("<=768px")
              svg
                width: 1.5rem

        &__title
            font-size: 1.125rem
            color: $color-banner-title
            font-weight: bold
            margin-left: 1rem !important
            margin-right: 1rem !important
            +media("<=768px")
              margin-left: 0.8rem !important

        .button
            text-transform: none
            padding-top: 0.5rem
            padding-bottom: 0.5rem


            + .button
                margin-top: 0.5rem

        .button--banner
          width: 365px
          height: 51px
          margin-left: 1rem
          font-size: 1.125rem
          svg
            transition: none
            stroke: none
</style>

